import { Language } from '@app/models/language';
import { Action } from '@ngrx/store';

export enum LanguagesActionTypes {
  FetchLanguages = '[Languages] Fetch Languages',
  FetchLanguagesSuccess = '[Languages] Fetch Languages Success',
  FetchLanguagesFail = '[Languages] Fetch Languages Fail'
}

export class FetchLanguages implements Action {
  readonly type = LanguagesActionTypes.FetchLanguages;
}

export class FetchLanguagesSuccess implements Action {
  readonly type = LanguagesActionTypes.FetchLanguagesSuccess;

  constructor(public payload: Language[]) {
  }
}

export class FetchLanguagesFail implements Action {
  readonly type = LanguagesActionTypes.FetchLanguagesFail;

  constructor(public payload: Error) {
  }
}

export type LanguagesActions =
  | FetchLanguages
  | FetchLanguagesSuccess
  | FetchLanguagesFail;
